import { render, staticRenderFns } from "./SettingsBlock.vue?vue&type=template&id=1fe44b0e&scoped=true&"
import script from "./SettingsBlock.vue?vue&type=script&lang=js&"
export * from "./SettingsBlock.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBlock.vue?vue&type=style&index=0&id=1fe44b0e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe44b0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCardTitle})
